<div
  class="payment-form min-h-screen w-full bg-white"
  *ngIf="(!status || status === 'Cancelled') && !notFound && paymentRequest">
  <ew-welcome
    *ngIf="welcome && isMobile"
    [paymentRequest]="paymentRequest"
    (hidden)="welcome = false"></ew-welcome>

  <ng-container *ngTemplateOutlet="header"></ng-container>
  <mat-progress-bar
    mode="determinate"
    [value]="(stepper.selectedIndex + 1) * 25"
    *ngIf="stepper"></mat-progress-bar>
  <section class="flex w-full justify-between">
    <div class="container-sm sm:container mx-auto block max-w-full">
      <mat-stepper
        class="v2 xs:w-[95%] mx-auto my-auto mt-4 w-[80%] sm:w-[90%] md:w-[90%]"
        [linear]="true"
        #stepper
        *ngIf="!notFound"
        [selectedIndex]="selectedIndex"
        [orientation]="'horizontal'"
        (selectionChange)="onStepChange($event)">
        <mat-step [stepControl]="payment">
          <div class="m-auto w-full lg:w-[80%]">
            <ng-template matStepLabel>
              <div
                class="custom-header"
                [class.active]="stepper.selectedIndex >= 0">
                <div class="number">1</div>
                <span>{{ 'paymentLink:step1Label' | translate }}</span>
              </div>
            </ng-template>

            <div class="xs:hidden">
              <p
                class="my-10 xs:my-6 text-center text-2xl"
                *ngIf="this.paymentRequest?.type === 'AGENCY_PAYMENT'">
                {{ 'agencyPaymentRequest:pay' | translate }}
                {{ paymentRequest?.agency?.name }}
              </p>
              <div
                class="text-center"
                *ngIf="this.paymentRequest?.type === 'DEPOSIT'">
                <p class="my-10 xs:my-6 text-5xl xs:text-2xl font-bold">
                  {{ 'shared:hi' | translate }}, {{ student.value.firstname }}
                  {{ student.value.lastname }}
                </p>
                <p class="mb-10">
                  {{ 'createRequestMoney:paymentSubtitle1Form2' | translate }}
                  <b>#{{ paymentRequest.order.orderId }}</b>
                  {{ 'createRequestMoney:paymentSubtitle2Form2' | translate }}
                  <b>{{ paymentRequest.order.providerName }}</b>
                </p>
              </div>
              <p class="mb-12 text-center text-5xl text-gray-900">
                <ew-format-currency
                  [amount]="paymentAmount"
                  [currency]="paymentCurrency"></ew-format-currency>
              </p>
            </div>

            <div class="xs:block hidden">
              <p class="my-10 xs:my-6 text-5xl xs:text-2xl font-bold">
                {{ 'paymentLink:step1Label' | translate }}
              </p>
              <p class="mb-10">
                {{ 'paymentLink:step1Subtitle' | translate }}
              </p>
            </div>

            <form [formGroup]="payment">
              <ew-select-country
                [width]="'100%'"
                [value]="payment.value.countryPayFrom"
                (valueChanged)="
                  payment.patchValue({
                    countryPayFrom: $event.iso,
                    paymentMethod: null
                  });
                  onPayerCountryChange()
                "
                [label]="'agencyPaymentRequest:paymentCountryOrigin'"
                [isAvailableToSendPayment]="true"></ew-select-country>

              <mat-form-field *ngIf="showInputStates" class="w-full">
                <mat-label class="font-semibold">
                  {{ 'createRequestMoney:paymentStatePayFrom' | translate }}
                  <small class="text-gray-400">
                    ({{ 'shared:required' | translate }})
                  </small>
                </mat-label>
                <mat-select formControlName="statePayFrom">
                  <mat-option
                    [value]="item.provinceId"
                    *ngFor="let item of states">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="payment.controls['statePayFrom'].errors">
                  <span>
                    {{ 'createRequestMoney:paymentStatePayFrom' | translate }}
                  </span>
                  <strong> {{ 'shared:isRequired' | translate }}</strong>
                </mat-error>
              </mat-form-field>

              <div class="flex w-full justify-center">
                <mat-progress-spinner
                  *ngIf="loading"
                  [diameter]="40"
                  [mode]="'indeterminate'"></mat-progress-spinner>
              </div>

              <ew-payment-methods
                *ngIf="!loading"
                [paymentMethods]="paymentMethods"
                [value]="payment.value.paymentMethod"
                (valueChanged)="
                  paymentMethodChanged($event);
                  payment.patchValue({
                    paymentMethod: $event
                  })
                "
                [show]="payment.value.countryPayFrom"></ew-payment-methods>

              <treo-message
                class="mt-3"
                [appearance]="'outline'"
                [showIcon]="true"
                [showButtonClose]="false"
                [type]="'info'"
                *ngIf="!paymentMethods.length && !loading">
                <div>
                  {{ 'createRequestMoney:noPaymentMethods' | translate }}
                </div>
              </treo-message>
            </form>

            <div class="v2 buttons-container">
              <button
                mat-flat-button
                matStepperNext
                color="primary"
                [disabled]="!payment.valid">
                {{ 'shared:next' | translate }}
                <span class="xs:hidden">
                  : {{ 'createRequestMoney:studentTitle2' | translate }}
                </span>
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step [stepControl]="student">
          <div class="m-auto w-full lg:w-[80%]">
            <ng-template matStepLabel>
              <div
                class="custom-header"
                [class.active]="stepper.selectedIndex >= 1">
                <div class="number">2</div>
                <span>{{ 'paymentLink:step2Label' | translate }}</span>
              </div>
            </ng-template>

            <p class="my-10 xs:my-6 text-5xl xs:text-2xl font-bold">
              {{ 'createRequestMoney:studentTitle2' | translate }}
            </p>
            <p class="mb-10">
              {{ 'createRequestMoney:studentSubtitle2' | translate }}
            </p>

            <form [formGroup]="student">
              <ng-template matStepLabel>{{
                'paymentRequest:column2' | translate
              }}</ng-template>

              <!-- firstname -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputName' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="firstname"
                  name="firstname"
                  placeholder="" />
                <mat-error *ngIf="student.controls['firstname'].errors">
                  <span>
                    {{ 'createRequestMoney:studentInputName' | translate }}
                  </span>
                  <strong> {{ 'shared:isRequired' | translate }}</strong>
                </mat-error>
              </mat-form-field>

              <!-- lastname -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputSurname' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="lastname"
                  name="lastname"
                  placeholder="" />
                <mat-error *ngIf="student.controls['lastname'].errors">
                  <span>
                    {{ 'createRequestMoney:studentInputSurname' | translate }}
                  </span>
                  <strong> {{ 'shared:isRequired' | translate }}</strong>
                </mat-error>
              </mat-form-field>

              <!-- country -->
              <ew-select-country
                [width]="'100%'"
                [value]="student.value.country"
                (valueChanged)="
                  student.patchValue({
                    country: $event.iso
                  })
                "
                [label]="'createRequestMoney:studentInputCountry'"
                [disabled]="true">
              </ew-select-country>

              <!-- city -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputCity' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="city"
                  name="city"
                  placeholder="" />
                <mat-error *ngIf="student.controls['city'].errors">
                  <span *ngIf="student.controls['city'].errors['required']">
                    {{ 'createRequestMoney:studentInputCity' | translate }}
                    <strong> {{ 'shared:isRequired' | translate }}</strong>
                  </span>

                  <span *ngIf="student.controls['city'].errors['maxlength']">
                    {{
                      student.controls['city'].errors['maxlength']
                        | errorMaxValue
                    }}
                  </span>
                </mat-error>
              </mat-form-field>

              <!-- address -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputAddress' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="address"
                  name="address"
                  placeholder="" />
                <mat-error *ngIf="student.controls['address'].errors">
                  <span *ngIf="student.controls['address'].errors['required']">
                    {{ 'createRequestMoney:studentInputAddress' | translate }}
                    <strong> {{ 'shared:isRequired' | translate }}</strong>
                  </span>
                  <span *ngIf="student.controls['address'].errors['minlength']">
                    {{
                      student.controls['address'].errors['minlength']
                        | errorMinValue
                    }}
                  </span>
                  <span *ngIf="student.controls['address'].errors['maxlength']">
                    {{
                      student.controls['address'].errors['maxlength']
                        | errorMaxValue
                    }}
                  </span>
                </mat-error>
              </mat-form-field>

              <!-- postalCode -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputPostalCode' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="postalCode"
                  name="postalCode"
                  placeholder="" />
                <mat-error *ngIf="student.controls['postalCode'].errors">
                  <span
                    *ngIf="student.controls['postalCode'].errors['required']">
                    {{
                      'createRequestMoney:studentInputPostalCode' | translate
                    }}
                    <strong> {{ 'shared:isRequired' | translate }}</strong>
                  </span>
                  <span
                    *ngIf="student.controls['postalCode'].errors['maxlength']">
                    {{
                      student.controls['postalCode'].errors['maxlength']
                        | errorMaxValue
                    }}
                  </span>
                  <span
                    *ngIf="student.controls['postalCode'].errors['minlength']">
                    {{
                      student.controls['postalCode'].errors['minlength']
                        | errorMinValue
                    }}
                  </span>
                </mat-error>
              </mat-form-field>

              <!-- dateOfBirth -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputBirthday' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="dateOfBirth"
                  (click)="picker.open()"
                  required />
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #picker
                  color="primary"
                  [startAt]="startDate"
                  startView="multi-year">
                </mat-datepicker>
                <mat-error *ngIf="student.controls['dateOfBirth'].errors">
                  <span>
                    {{ 'createRequestMoney:studentInputBirthday' | translate }}
                  </span>
                  <strong> {{ 'shared:isRequired' | translate }}</strong>
                </mat-error>
              </mat-form-field>

              <!-- email -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputEmail' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="email"
                  name="email"
                  placeholder="" />
                <mat-error *ngIf="student.controls['email'].errors">
                  <span *ngIf="student.controls['email'].errors['required']">
                    {{ 'createRequestMoney:studentInputEmail' | translate }}
                    <strong>
                      {{ 'shared:isRequired' | translate }}
                    </strong>
                  </span>
                  <span *ngIf="student.controls['email'].errors['email']">{{
                    'shared:formatEmail' | translate
                  }}</span>

                  <span *ngIf="student.controls['email'].errors['maxlength']">
                    {{
                      student.controls['email'].errors['maxlength']
                        | errorMaxValue
                    }}
                  </span>
                </mat-error>
              </mat-form-field>

              <!-- phoneNumber -->
              <mat-form-field class="w-full">
                <mat-label>
                  {{ 'createRequestMoney:studentInputPhoneNumber' | translate }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="phoneNumber"
                  name="phoneNumber"
                  type="tel"
                  inputmode="tel"
                  placeholder="" />
                <mat-error *ngIf="student.controls['phoneNumber'].errors">
                  <span
                    *ngIf="student.controls['phoneNumber'].errors['required']"
                    >{{
                      'createRequestMoney:studentInputPhoneNumber' | translate
                    }}
                    <strong> {{ 'shared:isRequired' | translate }}</strong>
                  </span>
                  <span
                    *ngIf="student.controls['phoneNumber'].errors['minlength']">
                    {{
                      student.controls['phoneNumber'].errors['minlength']
                        | errorMinValue
                    }}
                  </span>
                  <span
                    *ngIf="student.controls['phoneNumber'].errors['maxlength']">
                    {{
                      student.controls['phoneNumber'].errors['maxlength']
                        | errorMaxValue
                    }}
                  </span>
                </mat-error>
              </mat-form-field>
            </form>
            <div class="v2 buttons-container">
              <button mat-button matStepperPrevious>
                {{ 'shared:back' | translate }}
              </button>
              <button
                mat-flat-button
                matStepperNext
                color="primary"
                [disabled]="!student.valid">
                {{ 'shared:next' | translate }}
                <span class="xs:hidden">
                  : {{ 'createRequestMoney:payerTitle' | translate }}
                </span>
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step [completed]="payer.valid && submitted">
          <div class="m-auto w-full lg:w-[80%]">
            <ng-template matStepLabel>
              <div
                class="custom-header"
                [class.active]="stepper.selectedIndex >= 2">
                <div class="number">3</div>
                <span>{{ 'paymentLink:step3Label' | translate }}</span>
              </div>
            </ng-template>

            <p class="my-10 xs:my-6 text-5xl xs:text-2xl font-bold">
              {{ 'createRequestMoney:payerTitle' | translate }}
            </p>

            <!-- message -->
            <treo-message
              class="mb-3"
              [appearance]="message.appearance"
              [showIcon]="message.showIcon"
              [showButtonClose]="message.showButtonClose"
              [type]="message.type"
              *ngIf="message">
              <div treoMessageTitle *ngIf="message.title">
                {{ message.title | translate }}
              </div>
              <div>
                {{ message.content | translate }}
              </div>
            </treo-message>

            <p class="mb-10">
              {{ 'createRequestMoney:payerSubtitle' | translate }}
            </p>

            <form [formGroup]="payer">
              <mat-form-field
                class="w-full"
                *ngIf="this.paymentRequest?.type === 'AGENCY_PAYMENT'"
                disabled>
                <mat-label>
                  {{ 'agencyPaymentRequest:whoIsMakingThePayment' | translate }}
                  <small class="text-gray-400">
                    ({{ 'shared:required' | translate }})
                  </small>
                </mat-label>
                <mat-select formControlName="whoIsMakingThePayment" required>
                  <mat-option [value]="item.value" *ngFor="let item of payers">
                    <div class="flex items-center">
                      {{ item.label | translate }}
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field
                class="w-full"
                *ngIf="this.paymentRequest?.type === 'DEPOSIT'">
                <mat-label>
                  {{
                    'createRequestMoney:payerInputWhoIsMakingThePayment'
                      | translate
                  }}
                  <small class="text-gray-400">
                    ({{ 'shared:required' | translate }})
                  </small>
                </mat-label>
                <mat-select
                  formControlName="whoIsMakingThePayment"
                  (selectionChange)="handleWhoIsMakingThePaymentChanges()">
                  <mat-option value="STUDENT">{{
                    'createRequestMoney:payerInputWhoIsMakingThePaymentOptionSTUDENT'
                      | translate
                  }}</mat-option>
                  <mat-option value="FATHER">{{
                    'createRequestMoney:payerInputWhoIsMakingThePaymentOptionFATHER'
                      | translate
                  }}</mat-option>
                  <mat-option value="MOTHER">{{
                    'createRequestMoney:payerInputWhoIsMakingThePaymentOptionMOTHER'
                      | translate
                  }}</mat-option>
                  <mat-option value="RELATIVE">{{
                    'createRequestMoney:payerInputWhoIsMakingThePaymentOptionRELATIVE'
                      | translate
                  }}</mat-option>
                  <mat-option value="EDUCATION_AGENT">{{
                    'createRequestMoney:payerInputWhoIsMakingThePaymentOptionEDUCATION_AGENT'
                      | translate
                  }}</mat-option>
                  <mat-option value="OTHER">{{
                    'createRequestMoney:payerInputWhoIsMakingThePaymentOptionOTHER'
                      | translate
                  }}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="payer.controls['whoIsMakingThePayment'].errors">
                  <span>
                    {{
                      'createRequestMoney:payerInputWhoIsMakingThePayment'
                        | translate
                    }}
                  </span>
                  <strong> {{ 'shared:isRequired' | translate }}</strong>
                </mat-error>
              </mat-form-field>

              <!-- document -->
              <mat-form-field class="w-full" *ngIf="documentRequired">
                <mat-label>
                  {{ documentLabel }}
                  <small>({{ 'shared:required' | translate }})</small>
                </mat-label>
                <input
                  matInput
                  required
                  formControlName="document"
                  name="document"
                  [placeholder]="documentExample"
                  [mask]="documentMask ? documentMask : null"
                  [dropSpecialCharacters]="false" />
                <mat-error *ngIf="payer.controls['document'].errors">
                  <span *ngIf="payer.controls['document'].errors['required']">
                    {{ documentLabel }}
                    <strong>
                      {{ 'shared:isRequired' | translate }}
                    </strong>
                  </span>
                  <span *ngIf="payer.controls['document'].errors['pattern']">
                    {{ documentLabel }}
                    <strong>
                      {{ 'shared:formatIncorrect' | translate }} (ex.:
                      {{ documentExample }})
                    </strong>
                  </span>
                </mat-error>
              </mat-form-field>

              <!-- uploaded document -->
              <ng-container *ngIf="documentPassportRequired && requestIdUpload">
                <ew-upload-documents
                  uploader
                  [isIncludedInsideMatForm]="true"
                  [isProofOfPayment]="wasPassportAlreadyUploaded"
                  [required]="documentPassportRequired && requestIdUpload"
                  [buttonTextUpload]="
                    'paymentRequest:uploadDocument' | translate
                  "
                  [files]="documentIdToUpload"
                  [acceptedTypes]="[
                    'image/jpg',
                    'image/jpeg',
                    'image/png',
                    'application/pdf'
                  ]"
                  [maxSize]="25_000_000"
                  [noAuthUpload]="true"
                  [uploadedDocumentsIds]="uploadedDocumentsIds"
                  (documentsUploaded)="
                    handleIdFileUpload()
                  "></ew-upload-documents>
                <div class="mt-6"></div>
              </ng-container>

              <!-- country -->
              <ew-select-country
                [width]="'100%'"
                [value]="
                  payer.value.whoIsMakingThePayment === 'STUDENT'
                    ? student.value.country
                    : payer.value.country
                "
                (valueChanged)="
                  payer.patchValue({
                    country: $event.iso
                  })
                "
                [label]="'createRequestMoney:payerInputCountry'"
                [disabled]="
                  payer.value.whoIsMakingThePayment === 'STUDENT'
                    ? student.value.country
                    : payer.value.country
                "
                [isAvailableToSendPayment]="true">
              </ew-select-country>

              <div
                *ngIf="payer.value.whoIsMakingThePayment === 'STUDENT'"
                class="cursor-pointer text-blue-500 mb-4"
                (click)="hideDetails = !hideDetails">
                {{
                  (hideDetails
                    ? 'studentPaymentV2:showDetails'
                    : 'studentPaymentV2:hideDetails'
                  ) | translate
                }}
                <i
                  class="mr-2 fa-solid fa-caret-right"
                  [class.fa-rotate-90]="!hideDetails"></i>
              </div>

              <ng-container *ngIf="!hideDetails">
                <!-- firstname -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputName' | translate }}
                    <small>({{ 'shared:required' | translate }}) </small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="firstname"
                    name="firstname"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['firstname'].errors">
                    <span>
                      {{ 'createRequestMoney:payerInputName' | translate }}
                    </span>
                    <strong> {{ 'shared:isRequired' | translate }}</strong>
                  </mat-error>
                </mat-form-field>

                <!-- lastname -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputSurname' | translate }}
                    <small>({{ 'shared:required' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="lastname"
                    name="lastname"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['lastname'].errors">
                    <span>
                      {{ 'createRequestMoney:payerInputSurname' | translate }}
                    </span>
                    <strong> {{ 'shared:isRequired' | translate }}</strong>
                  </mat-error>
                </mat-form-field>

                <!-- city -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputCity' | translate }}
                    <small>({{ 'shared:required' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="city"
                    name="city"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['city'].errors">
                    <span *ngIf="payer.controls['city'].errors['required']">
                      {{ 'createRequestMoney:payerInputCity' | translate }}
                      <strong> {{ 'shared:isRequired' | translate }}</strong>
                    </span>

                    <span *ngIf="payer.controls['city'].errors['maxlength']">
                      {{
                        payer.controls['city'].errors['maxlength']
                          | errorMaxValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <!-- address -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputAddress' | translate }}
                    <small>({{ 'shared:required' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="address"
                    name="address"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['address'].errors">
                    <span *ngIf="payer.controls['address'].errors['required']">
                      {{ 'createRequestMoney:payerInputAddress' | translate }}
                      <strong> {{ 'shared:isRequired' | translate }}</strong>
                    </span>
                    <span *ngIf="payer.controls['address'].errors['minlength']">
                      {{
                        payer.controls['address'].errors['minlength']
                          | errorMinValue
                      }}
                    </span>
                    <span *ngIf="payer.controls['address'].errors['maxlength']">
                      {{
                        payer.controls['address'].errors['maxlength']
                          | errorMaxValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <!-- postalCode -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputPostalCode' | translate }}
                    <small>({{ 'shared:required' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="postalCode"
                    name="postalCode"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['postalCode'].errors">
                    <span
                      *ngIf="payer.controls['postalCode'].errors['required']">
                      {{
                        'createRequestMoney:payerInputPostalCode' | translate
                      }}
                      <strong> {{ 'shared:isRequired' | translate }}</strong>
                    </span>
                    <span
                      *ngIf="payer.controls['postalCode'].errors['maxlength']">
                      {{
                        payer.controls['postalCode'].errors['maxlength']
                          | errorMaxValue
                      }}
                    </span>
                    <span
                      *ngIf="payer.controls['postalCode'].errors['minlength']">
                      {{
                        payer.controls['postalCode'].errors['minlength']
                          | errorMinValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <!-- email -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputEmail' | translate }}
                    <small>({{ 'shared:required' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="email"
                    name="email"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['email'].errors">
                    <span *ngIf="payer.controls['email'].errors['required']">
                      {{ 'createRequestMoney:payerInputEmail' | translate }}
                      <strong> {{ 'shared:isRequired' | translate }}</strong>
                    </span>
                    <span *ngIf="payer.controls['email'].errors['email']">
                      {{ 'shared:formatEmail' | translate }}
                    </span>

                    <span *ngIf="payer.controls['email'].errors['maxlength']">
                      {{
                        payer.controls['email'].errors['maxlength']
                          | errorMaxValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <!-- phoneNumber -->
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputPhoneNumber' | translate }}
                    <small>({{ 'shared:required' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    inputmode="tel"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['phoneNumber'].errors">
                    <span
                      *ngIf="payer.controls['phoneNumber'].errors['required']">
                      {{
                        'createRequestMoney:payerInputPhoneNumber' | translate
                      }}
                      <strong> {{ 'shared:isRequired' | translate }}</strong>
                    </span>
                    <span
                      *ngIf="payer.controls['phoneNumber'].errors['minlength']">
                      {{
                        payer.controls['phoneNumber'].errors['minlength']
                          | errorMinValue
                      }}
                    </span>
                    <span
                      *ngIf="payer.controls['phoneNumber'].errors['maxlength']">
                      {{
                        payer.controls['phoneNumber'].errors['maxlength']
                          | errorMaxValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>
              </ng-container>

              <div class="mt-6 w-full text-center">
                <mat-checkbox
                  [color]="'primary'"
                  formControlName="termsAccepted">
                  {{ 'createRequestMoney:termsAndConditionsText' | translate }}
                  <a
                    class="link whitespace-nowrap ml-1"
                    (click)="
                      $event.preventDefault(); openTermsAndConditionsDialog()
                    ">
                    {{ 'shared:termsOfUse' | translate }}
                  </a>
                </mat-checkbox>
              </div>
            </form>

            <div class="v2 buttons-container">
              <button mat-button matStepperPrevious [disabled]="loading">
                {{ 'shared:back' | translate }}
              </button>
              <button
                mat-flat-button
                color="primary"
                (click)="submit(stepper)"
                [disabled]="
                  !this.payment.valid ||
                  !this.student.valid ||
                  !this.payer.valid ||
                  this.loading
                ">
                <span *ngIf="!loading">
                  {{ 'shared:next' | translate }}
                  <span class="xs:hidden">
                    : {{ 'agencyPaymentRequest:confirmation' | translate }}
                  </span>
                </span>
                <mat-progress-spinner
                  [diameter]="20"
                  [mode]="'indeterminate'"
                  *ngIf="loading"></mat-progress-spinner>
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step [stepControl]="confirmation">
          <div class="m-auto w-full lg:w-[80%]">
            <ng-template matStepLabel>
              <div
                class="custom-header"
                [class.active]="stepper.selectedIndex >= 3">
                <div class="number">4</div>
                <span>{{ 'paymentLink:step4LabelPayment' | translate }}</span>
              </div>
            </ng-template>

            <treo-message
              class="mb-3"
              [appearance]="creditCardAlert.appearance"
              [showIcon]="creditCardAlert.showIcon"
              [showButtonClose]="creditCardAlert.showButtonClose"
              [type]="creditCardAlert.type"
              *ngIf="showCreditCard && status != 'Cancelled'">
              <div>
                <span>
                  <b>{{ creditCardAlert.title! | translate }}:</b>
                  {{
                    (creditCardAlert.content | translate).replace(
                      ':paymentCurrency',
                      paymentRequest?.payment?.convertedCurrency
                    )
                  }}
                </span>
              </div>
            </treo-message>

            <section
              class="mb-10 p-6 border-gray-300 border-solid border rounded-lg"
              *ngIf="
                paymentLinkNotWorkingFeatureFlag &&
                redirectUrl &&
                !showBankTransfer
              ">
              <h2 class="mb-8">
                {{ 'externalBankTransfer:instructionsTitle' | translate }}
              </h2>
              <p class="mb-6">
                {{ 'externalBankTransfer:instructionsText' | translate }}
              </p>
              <div class="text-center">
                <a
                  [href]="redirectUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="inline-block bg-blue-600 text-white py-2 px-4 rounded-lg">
                  <i class="fa-solid fa-arrow-up-right-from-square mr-2"></i>
                  {{
                    'externalBankTransfer:instructionsButtonText' | translate
                  }}
                </a>
              </div>
            </section>

            <iframe
              title="transfermate payment"
              [src]="redirectUrl"
              style="min-height: 805px; width: 100%"
              scrolling="auto"
              frameborder="0"
              allowfullscreen="true"
              *ngIf="
                !paymentLinkNotWorkingFeatureFlag && showCreditCard && !status
              "></iframe>

            <ew-payment-rejected
              *ngIf="status == 'Cancelled'"
              (changePaymentMethod)="
                changePaymentMethod()
              "></ew-payment-rejected>

            <bank-transfer-v2
              *ngIf="showBankTransfer && status != 'Cancelled'"
              [ngClass]="{ 'block mb-40 xs:mb-0': !isChangingPaymentAllowed() }"
              [paymentUuid]="paymentRequest?.uuid"
              [paymentMethods]="paymentMethods"
              [paymentMethodId]="paymentRequest?.payment?.paymentMethod"
              [expiryDate]="instructionExpiry"
              [externalPaymentUrl]="redirectUrl"
              [paymentAmount]="paymentRequest?.payment?.amount"
              [paymentCurrency]="paymentRequest?.payment?.currency"
              [convertedAmount]="paymentRequest?.payment?.convertedAmount"
              [convertedCurrency]="paymentRequest?.payment?.convertedCurrency"
              [bankTransferData]="paymentRequest?.payment?.instructions"
              [parsedInstructions]="paymentRequest?.payment?.parsedInstructions"
              (uploadProofOfPayment)="openMatAccordion()"
              (changePaymentMethod)="changePaymentMethodAlert()">
            </bank-transfer-v2>

            <ng-container *ngIf="isChangingPaymentAllowed()">
              <div
                class="my-6 flex flex-wrap items-center content-start place-content-center gap-2.5 h-[11.5rem] xs:h-[5rem]">
                <p>
                  {{
                    'agencyPaymentRequest:changePaymentDescription' | translate
                  }}
                </p>
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="changePaymentMethod()"
                  class="min-w-44">
                  <i class="fa-regular fa-rotate-right mr-2"></i>
                  <span>
                    {{ 'agencyPaymentRequest:changePayment' | translate }}
                  </span>
                </button>
              </div>
            </ng-container>
          </div>

          <ew-mat-accordion
            #matAccordion
            [hidden]="expired || !isBankTransfer()"
            [translations]="
              getTranslations(!additionalDocuments, hasUploadedDocs)
            ">
            <ew-upload-documents
              uploader
              [isProofOfPayment]="true"
              [title]="'uploadDocuments:title'"
              [subtitle]="'uploadDocuments:subtitle'"
              [files]="proofOfPaymentToUpload"
              [expirationDate]="intentExpirationDate"
              [noAuthUpload]="true"
              [uploadedDocumentsIds]="uploadedDocumentsId"
              (documentsUploaded)="uploadDocuments()"></ew-upload-documents>
          </ew-mat-accordion>
        </mat-step>
      </mat-stepper>

      <ew-summary
        [paymentRequest]="paymentRequest"
        *ngIf="
          !notFound && !status && stepper && stepper.selectedIndex < 3
        "></ew-summary>
    </div>
  </section>
</div>

<!-- notFound -->
<div *ngIf="notFound" class="h-20">
  <ng-container *ngTemplateOutlet="header"></ng-container>
  <main
    class="w-full h-[calc(100vh-56px)] flex flex-col justify-center items-center bg-white p-10">
    <div class="flex flex-col text-center mb-10">
      <h1 class="mb-6">{{ 'paymentLink:404Title' | translate }}</h1>
      <span class="text-gray-500">
        {{ 'paymentLink:404LinkUnavailable' | translate }}
      </span>
      <span class="text-gray-500">
        {{ 'shared:please' | translate }},
        <b>{{ 'paymentLink:404ContactSupport' | translate }}</b>
      </span>
    </div>
    <img
      class="max-h-[600px] max-w-[600px]"
      src="assets/404-student-payment.png"
      alt="payment not found" />
  </main>
</div>

<!-- tracking -->
<ew-tracking
  [data]="tracking"
  *ngIf="status && status !== 'Cancelled'"></ew-tracking>

<!-- template -->
<ng-template #dialogTemplate>
  <h2 mat-dialog-title>{{ 'alert:changePaymentMethod' | translate }}</h2>
  <mat-dialog-content>
    <p>{{ 'alert:changePaymentMethodMessage' | translate }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>
      {{ 'shared:close' | translate }}
    </button>
    <button
      mat-button
      [mat-dialog-close]="true"
      color="primary"
      cdkFocusInitial>
      {{ 'shared:proceed' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- header -->
<ng-template #header>
  <header
    class="xs:px-2 flex w-full items-center justify-between bg-white px-16 py-2 shadow-lg"
    *ngIf="!isTheFormOnIframe()">
    <div class="flex items-center">
      <img
        *ngIf="companyLogo && companyLogo !== ''"
        src="{{ companyLogo }}"
        alt="{{ companyName }}"
        class="block max-w-[50px] h-auto mr-3 rounded-lg" />
      <span class="block text-lg font-semibold">{{ companyName }}</span>
    </div>
    <ew-languages [navbar]="!isMobile"></ew-languages>
  </header>
</ng-template>
